import React, { useState, useEffect } from 'react';
import { notificarError, notificarMsg } from './Almacenes/AlmacenNotify';

const UsuarioCajasEmpresa = ({ Usuario, closeModal }) => {
    const [cajas, setCajas] = useState(null);

    useEffect(() => {
        fetchCajas();
    }, []);

    const fetchCajas = async () => {
        try {
            const response = await fetch(
                `/api/usuarios/empresa/${Usuario.IdUsuario}/cajas?IdSucursal=${Usuario.IdSucursal}`
            );
            
            if (!response.ok) {
                const error = await response.json();
                return notificarError(error.error || "Error al cargar cajas");
            }
            
            const data = await response.json();
            setCajas(data);
        } catch (error) {
            notificarError("Error al cargar cajas");
        }
    };

    const onToggleCaja = (IdCaja) => {
        const caja = cajas.find(caja => caja.IdCaja === IdCaja);
        caja.Activo = !caja.Activo;
        setCajas([...cajas]);
    };

    const onToggleAll = () => {
        const allActive = cajas.every(caja => caja.Activo);
        const newCajas = cajas.map(caja => ({
            ...caja,
            Activo: !allActive
        }));
        setCajas(newCajas);
    };

    const onGuardar = async () => {
        try {
            const response = await fetch(`/api/usuarios/empresa/${Usuario.IdUsuario}/cajas`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Cajas: cajas.map(caja => ({
                        IdCaja: caja.IdCaja,
                        Activo: caja.Activo
                    })),
                    IdSucursal: Usuario.IdSucursal
                })
            });

            if (response.ok) {
                notificarMsg("Configuración de cajas guardada correctamente.");
                if (closeModal) closeModal();
            } else {
                const error = await response.json();
                notificarError(error.error || "Error al guardar la configuración de cajas.");
            }
        } catch (error) {
            notificarError("Error al guardar la configuración de cajas.");
        }
    };

    const allActive = cajas && cajas.length > 0 ? cajas.every(caja => caja.Activo) : false;

    return (
        <div className='px-3 mt-2'>
            <div>
                <div className="form-check mt-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="all"
                        checked={allActive}
                        onChange={onToggleAll}
                    />
                    <label className="form-check-label" htmlFor="all">
                        {allActive ? "Deshabilitar todas" : "Habilitar todas"}
                    </label>
                </div>
                <hr />
                {cajas && cajas.map((caja) => (
                    <div key={caja.IdCaja} className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`caja-${caja.IdCaja}`}
                            checked={!!caja.Activo}
                            onChange={() => onToggleCaja(caja.IdCaja)}
                        />
                        <label className="form-check-label" htmlFor={`caja-${caja.IdCaja}`}>
                            {caja.Nombre}
                        </label>
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-end mt-3 mb-3">
                <button
                    className="btn btn-verde-mfp-letra-normal"
                    onClick={onGuardar}
                >
                    Guardar
                </button>
            </div>
        </div>
    );
};

export default UsuarioCajasEmpresa;
